import React from 'react'
import Layout from '../../layout/Layout'
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../utils/theme';
export default function PortofolioFundAllocation() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  return (
    <Layout>
      <section>
        <div className="container py-3">
          <div className="row justify-content-center d-none">
            <div className="col-md-6">
              <div className="border border-2 rounded-3 text-center p-3">
                <h3 className="fw-bold">Let's Create your Porfolio</h3>
                <p>Allocate funds to Porfolio</p>
                <button className="btn btn-dark rounded-3" onClick={() => { navigate('/my-account') }}> Add Funds Now</button>
              </div>
            </div>

          </div>
          <div class="row g-3 mb-3">
            <div class="col-md-12">
              <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
            </div>
            <div class="col-md-12">
              {/* <div class="border rounded-3 p-3"> */}
              <div
                className="border rounded-3 p-3"
                style={{
                  backgroundColor: theme === "dark" ? "#0A0A0B" : "",
                }}
              >
                <h1 class="fs-4 fw-bold ">Equity Portfolio Setup</h1>
                <p>Let's get started by setting up your equity portfolio. Add funds to begin.</p>
                <a href="/my-account" class="btn btn-dark">Add Funds</a>
                <p class="text-muted mt-3 mb-0"><small><b>Note:</b> This is not an actual fund transfer. The amount is used only to create a personalized dashboard for you.</small></p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </Layout>
  )
}
